import "./Header.css";
import logo from "./logo-ia-redesign.png";
//import logo from './logo.png';
import { IconButton, initializeIcons } from "office-ui-fabric-react";
import * as React from "react";
import { downloadQueueStore } from "./downloadQueueStore";
import { IPdmsUser } from "./IPdmsUser";
import { uploadQueueStore } from "./uploadQueueStore";

//import { initializeIcons } from "fluentui/react";
//import { IconButton } from 'fluentui/react';

//initializeIcons();
//added on 20250206, to resolve the microsoft cdn issue/bug
initializeIcons(
  "https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/",
);

//ReactDOM.render(<ChevronUpIcon />, document.body.firstChild);

export interface IHeaderProps {
  currentUser?: IPdmsUser;
  currentUserInProject?: IPdmsUser;
}
export interface IHeaderState {
  token?: string;
}
export default class Header extends React.Component<
  IHeaderProps,
  IHeaderState
> {
  constructor(props: IHeaderProps | Readonly<IHeaderProps>) {
    super(props);
    this.state = {};
  }

  public render(): React.ReactElement<IHeaderProps> {
    return (
      <div className="header">
        <img alt="logo" width={150} src={logo} className="logo"></img>
        {/* <a href={logo} className="logo">CompanyLogo</a> */}
        <div className="header-right">
          <table className="header-right">
            <tbody>
              <tr>
                <td>
                  <label className="greeting">Welcome to PDMS Portal</label>
                  <label className="userInfo"></label>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="userInfo">
                    {this.props.currentUserInProject
                      ? `${this.props.currentUserInProject!.name}: ${this.props.currentUserInProject!.role!}`
                      : this.props.currentUser!.email}
                  </label>

                  {/* <a href="#Signout"  onClick={() => this.logoutByButtonHelper()} >Sign out</a> */}
                  <IconButton
                    iconProps={{ iconName: "Signout" }}
                    className="clearButton"
                    title="Sign out"
                    onClick={() => this.logoutByButtonHelper()}
                  />
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          {/* <IconButton iconProps={{ iconName: 'Signout' }} className="clearButton" title='Sign out'/> */}
          {/* <a href="#Signout"  onClick={() => this.logoutByButtonHelper()} >Sign out</a> */}
        </div>
      </div>
    );
  }

  componentDidUpdate(
    previousProps: IHeaderProps,
    previousState: IHeaderState,
  ) {}

  private logoutByButtonHelper() {
    const hasActiveUploads = uploadQueueStore
      .getItems()
      .some((it) => it.status === "uploading");
    const hasActiveDownloads = downloadQueueStore
      .getItems()
      .some((it) => it.status === "downloading");

    if (hasActiveUploads && hasActiveDownloads) {
      if (
        !window.confirm(
          "Files are still uploading and downloading. Logging out will cancel them. Continue?",
        )
      ) {
        return;
      }
    } else if (hasActiveUploads) {
      if (
        !window.confirm(
          "Files are still uploading. Logging out will cancel them. Continue?",
        )
      ) {
        return;
      }
    } else if (hasActiveDownloads) {
      if (
        !window.confirm(
          "Files are still downloading. Logging out will cancel them. Continue?",
        )
      ) {
        return;
      }
    }

    let element: HTMLElement = document.getElementById(
      "btnDistroyToken",
    ) as HTMLElement;
    element.click();
  }
}
